/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { DimObjectives } from './dimObjectives';

/**
 * For each dimensions: is it applicable (bool) and which demands fall under this dimension
 */
export type TaskObjectivesDimensions = { [key: string]: DimObjectives };
